"use client";

import { Accordion as BricksAccordion, IconFeatherChevronDown } from "@red-digital/bricks";
import cn from "classnames";
import React, { useState } from "react";
import { AccordionProps } from "./Accordion.types";
import AccordionWrapper from "./AccordionWrapper";

import { Button } from "../Button";
// @ts-ignore
import styles from "./Accordion.module.scss";

export const Accordion: React.FC<AccordionProps> = ({ sectionName, items, itemsVisible, orientation }) => {
  const [viewMore, setViewMore] = useState(false);
  const maxItemsToShow = itemsVisible || 5;

  return (
    <BricksAccordion
      className={cn(styles.accordion, {
        [styles.horizontal]: orientation === "horizontal",
        [styles.hiddenItems]: !viewMore,
      })}
      allowMultiple
      headingProps={{
        modifier: 700,
        type: "h3",
        variant: "heading-lg",
        className: styles.heading,
      }}
      icons={{
        collapsed: <IconFeatherChevronDown />,
        expanded: <IconFeatherChevronDown />,
      }}
      initialExpanded={
        items
          ?.map((item) => {
            if (item?.fields?.open) {
              return item.sys.id;
            }
            return "";
          })
          .filter((item) => item.length) || []
      }
    >
      {items?.map((item, index) => (
        <AccordionWrapper
          key={`${item?.sys?.id || "item"}-${index}`}
          item={item}
          itemKey={item?.sys?.id || `item-${index}`}
          style={!viewMore && index >= maxItemsToShow ? { display: "none" } : undefined}
          sectionName={sectionName}
          position={index + 1}
          orientation={orientation}
        />
      ))}
      {items && items?.length > maxItemsToShow && (
        <div className={`${styles.viewButton} ${viewMore ? styles.viewLess : styles.viewMore}`}>
          <Button
            variant="plain"
            color="primary"
            forceDarkLabel
            size="large"
            icon={viewMore ? "chevron-up" : "chevron-down"}
            onClick={() => setViewMore(!viewMore)}
          >
            View {viewMore ? "less" : "more"}
          </Button>
        </div>
      )}
    </BricksAccordion>
  );
};
